<template>

  <modalo
    :title="customField.label"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => customField">

    <form id="customField-form" v-on:submit.prevent="saveCustomField(customField)">

      <div class="form-group">
        <label>{{ $t('Group') }}</label>
        <select
          v-autofocus
          type="text"
          class="form-control"
          v-model="customField.custom_field_group_id">
          <option value="radio" v-for="(item, index) in groups" :value="item._id">{{ item.name }}</option>
        </select>
        <ValidateMessage :error="validateErrors.custom_field_group_id" />
      </div>

      <div class="form-group">
        <label>{{ $t('Title') }}</label>
        <input type="text" class="form-control" v-model="customField.label">
        <ValidateMessage :error="validateErrors.label" />
      </div>

      <div class="form-group">
        <label>{{ $t('Key') }}</label>
        <input type="text" class="form-control" v-model="customField.key" :disabled="customField._id">
        <ValidateMessage :error="validateErrors.key" />
      </div>

      <div class="form-group">
        <label>{{ $t('Required') }}</label>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="1" v-model="customField.required">
          <label class="form-check-label">
            {{ $t('Required') }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors.required" />
      </div>

      <div class="form-group">
        <label>{{ $t('Type') }}</label>
        <select type="text" class="form-control" v-model="customField.type">
          <option value="text">{{ $t('Short text') }}</option>
          <option value="textarea">{{ $t('Long text') }}</option>
          <option value="radio">{{ $t('List of options (Single choice)') }}</option>
          <option value="checkbox">Lista de opções (Muitas escolhas)</option>
          <option value="number">Número</option>
          <option value="date">Data</option>
        </select>
        <ValidateMessage :error="validateErrors.type" />
      </div>

      <div v-if="customField.type === 'radio' || customField.type === 'checkbox'">
          <ul
            class="form-items"
            v-sortable="{ handle: '.move', items: customField.options}">
            <li
              v-for="(item, item_index) in customField.options"
              :key="item_index">
              <div><a href="javascript:void(0)" class="move text-secondary"><i class="fas fa-arrows-alt" /></a></div>
              <div class="form-items-input">
                <input 
                  type="text" 
                  :placeholder="$t('Alternative')" 
                  v-model="customField.options[item_index]">
                <ValidateMessage :error="validateErrors['options.' + item_index]" />
              </div>
              <div><a href="javascript:void(0)" @click="removeOption(customField.options, item_index)"><i class="fas fa-times" /></a></div>
            </li>
          </ul>
          <br>
          <a
            href="javascript:void(0)"
            @click="addOption(customField.options)">{{ $t('Add item') }}</a>
        </div>
      </div>
      
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="customField-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="customField._id"
          type="button"
          class="btn btn-danger"
          @click="deleteCustomField(customField._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SlugFromString from '@/utils/SlugFromString'

export default {
  label: 'CustomFieldModal',
  components: {
  },
  props: [
    'initCustomField',
    'modelType'
  ],
  data () {
    return {
      groups: [],
      loading: false,
      customField: this.$clone(this.initCustomField),
      validateErrors: {}
    }
  },
  watch: {
    'customField.label' (newValue) {
      var slug = new SlugFromString(newValue).getSlug({spage: '_'})
      if (!this.customField._id) this.customField.key = slug
    }
  },
  created () {
    this.loadGroups()
  },
  methods: {
    /*
    Items
    */
    addOption (options) {
      options.push('')
    },
    removeOption (options, index) {
      options.splice(index, 1)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveCustomField
    */
    saveCustomField (data) {
      if (data._id) this.updateCustomField(data._id, data)
      else this.createCustomField(data)
    },
    /*
    createCustomField
    */
    createCustomField (data) {
      this.loading = true

      this.$store
      .dispatch('createCustomField', data)
      .then((result) => {
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateCustomField
    */
    updateCustomField (id, data) {
      this.loading = true

      this.$store
      .dispatch('updateCustomField', {
        ...data,
        _id: id
      })
      .then((result) => {
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    deleteCustomField
    */
    deleteCustomField (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteCustomField', id)
        .then((result) => {
          this.$emit('deleted')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    /*
    loadGroups
    */
    loadGroups () {
      this.$store
      .dispatch('getCustomFieldGroups', {
        'sort': 'position',
        'model_type': this.customField.model_type
      })
      .then(result => {
        this.groups = result
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CustomFields/CustomFieldForm.vue